import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局图片兜底指令：当图片加载失败或为空时显示默认图
Vue.directive('img-fallback', {
  inserted(el, binding) {
    // 默认的 SVG 占位图
    const defaultPlaceholder = 'data:image/svg+xml;utf8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400" viewBox="0 0 600 400">\
          <defs>\
            <linearGradient id="g" x1="0" x2="0" y1="0" y2="1">\
              <stop offset="0%" stop-color="#f5f5f5"/>\
              <stop offset="100%" stop-color="#e9e9e9"/>\
            </linearGradient>\
          </defs>\
          <rect width="100%" height="100%" fill="url(#g)"/>\
          <!-- 200x200 icon centered at (300,200) -->\
          <g transform="translate(200,100)">\
            <!-- frame -->\
            <rect x="0" y="0" width="200" height="200" rx="14" ry="14" fill="none" stroke="#d0d0d0" stroke-width="6"/>\
            <!-- avatar dot -->\
            <circle cx="145" cy="60" r="16" fill="#c7c7c7"/>\
            <!-- mountain -->\
            <path d="M20 160 L90 110 L120 135 L150 115 L180 165 L20 165 Z" fill="#c7c7c7"/>\
          </g>\
        </svg>'
    )

    // 如果传入的值为 null、undefined 或空字符串，则使用默认占位图
    const primary = binding.value && binding.value !== 'null' && binding.value !== 'undefined' 
      ? binding.value 
      : defaultPlaceholder
      
    const secondary = defaultPlaceholder

    const fallbacks = [primary, secondary]
    const imgEl = el.tagName.toLowerCase() === 'img' ? el : el.querySelector('img')
    if (!imgEl) return

    // 当前使用到第几个兜底
    let idx = 0

    const setFallback = () => {
      if (idx >= fallbacks.length) return
      const next = fallbacks[idx]
      idx += 1
      if (imgEl.getAttribute('src') !== next) {
        imgEl.setAttribute('src', next)
      }
    }

    // 如果初始 src 为空或为无效值，直接设置第一个占位图
    const currentSrc = imgEl.getAttribute('src')
    if (!currentSrc || currentSrc === 'null' || currentSrc === 'undefined' || currentSrc === '') {
      setFallback()
    }

    const onError = () => {
      setFallback()
    }

    imgEl.addEventListener('error', onError)

    el.__imgFallbackCleanup__ = () => {
      imgEl.removeEventListener('error', onError)
    }
  },
  unbind(el) {
    if (el.__imgFallbackCleanup__) {
      el.__imgFallbackCleanup__()
      delete el.__imgFallbackCleanup__
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')